import React from 'react'
import PropTypes from 'prop-types'
import { getPaletteColor, Flex } from 'pcln-design-system'
import styled from 'styled-components'

const propTypes = {
  children: PropTypes.node,
}

const defaultProps = {
  children: null,
}

const FooterText = styled(Flex)`
  border-top: 1px solid ${getPaletteColor('border.base')};
  ${(props) => props.theme.mediaQueries.sm} {
    padding-left: 16px;
  }
`

export const ItineraryFooter = ({ children, ...props }) => {
  return (
    <FooterText p={2} data-testid='itinerary-footer' alignItems='center' {...props}>
      {children}
    </FooterText>
  )
}

ItineraryFooter.propTypes = propTypes

ItineraryFooter.defaultProps = defaultProps
